import { Link } from "react-router-dom";
import { InfoWindow } from "@react-google-maps/api";

const DriverInfoWindow = ({
  driver,
  onClose,
  renderOrderStatus,
  updateSelectedDriver,
}) => {
  if (!driver) return null;

  const lat = Number(driver._position?.lat ?? driver.location.latitude);
  const lng = Number(driver._position?.lng ?? driver.location.longitude);

  return (
    <InfoWindow
      anchor={driver._marker}
      position={{ lat, lng }}
      onCloseClick={onClose}
      options={{
        disableAutoPan: true,
        pixelOffset: new window.google.maps.Size(0, -50),
      }}
    >
      <div className="p-3 shadow-sm rounded bg-body text-body">
        <div className="d-flex align-items-center mb-3">
          <img
            src={`${process.env.REACT_APP_API_PUBLIC_URL}${driver.profilePhoto}`}
            alt="Driver"
            className="rounded-circle me-3 border border-success"
            style={{ width: "48px", height: "48px", objectFit: "cover" }}
          />
          <div>
            <h6 className="mb-0">{driver.name}</h6>
            <small className="text-primary">{driver.workPhone}</small>
          </div>
        </div>

        {driver.orders?.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-sm table-bordered text-body mb-3">
              <tbody>
                <tr className="text-center text-dark">
                  <th>Order Id</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                {driver.orders.map((o) => (
                  <tr key={o._id}>
                    <td>{o.orderId}</td>
                    <td>{renderOrderStatus(o.status)}</td>
                    <td>
                      <Link
                        to={`/orders/order-details/${o._id}`}
                        target="_blank"
                        className="badge bg-primary text-white"
                      >
                        DETAILS
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-5 mx-5">No Current Order</div>
        )}

        <div className="d-flex justify-content-center gap-2">
          <button className="btn btn-danger btn-sm" onClick={onClose}>
            Close
          </button>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => updateSelectedDriver(driver?._id, true)}
          >
            Follow
          </button>
        </div>
      </div>
    </InfoWindow>
  );
};

export default DriverInfoWindow;
